function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* Custom JavaScript
-
-
-
-
-
-
-
-
-
*/

/* Category Icons Bar */
function hoverCatBar_01(){
  console.log('hoverCatBar_01 function started.');
  document.getElementById('cat-bar-img-01').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0649/5672/7473/files/Smart_for_Life_Cookie_Diet_Sleeves_-_Hover.png?v=1727223571');
};
function normalCatBar_01(){
  console.log('normalCatBar_01 function started.');
  document.getElementById("cat-bar-img-01").setAttribute("src", 'https://cdn.shopify.com/s/files/1/0649/5672/7473/files/Smart_for_Life_Cookie_Diet_Sleeves_-_Reg.png?v=1727223571');
};

function hoverCatBar_02(){
  console.log('hoverCatBar_02 function started.');
  document.getElementById('cat-bar-img-02').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0649/5672/7473/files/Smart_for_Life_Grab_Go_Cookies_-_Hover.png?v=1727223571');
};
function normalCatBar_02(){
  console.log('normalCatBar_02 function started.');
  document.getElementById('cat-bar-img-02').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0649/5672/7473/files/Smart_for_Life_Grab_Go_Cookies_-Reg.png?v=1727223571');
};


function hoverCatBar_03(){
  console.log('hoverCatBar_03 function started.');
  document.getElementById('cat-bar-img-03').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0232/4601/2494/files/SFL-CA-218x227-HP-Icons-_0007_218x227-Supplements---Hover.png?v=1668536069');
};
function normalCatBar_03(){
  console.log('normalCatBar_03 function started.');
  document.getElementById('cat-bar-img-03').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0232/4601/2494/files/SFL-CA-218x227-HP-Icons-_0006_218x227-Supplements.png?v=1668536065');
};

function hoverCatBar_04(){
  console.log('hoverCatBar_04 function started.');
  document.getElementById('cat-bar-img-04').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0649/5672/7473/files/SFL-CA-Icons_0007_218x227-Gummies---Hover.png?v=1723570754');
};
function normalCatBar_04(){
  console.log('normalCatBar_04 function started.');
  document.getElementById('cat-bar-img-04').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0649/5672/7473/files/SFL-CA-Icons_0006_218x227-Gummies.png?v=1723570754');
};


function hoverCatBar_05(){
  console.log('hoverCatBar_05 function started.');
  document.getElementById('cat-bar-img-05').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0232/4601/2494/files/SFL-CA-218x227-HP-Icons-_0009_218x227-Build-a-Box---Hover.png?v=1668536062');
};
function normalCatBar_05(){
  console.log('normalCatBar_05 function started.');
  document.getElementById('cat-bar-img-05').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0232/4601/2494/files/SFL-CA-218x227-HP-Icons-_0008_218x227-Build-a-Box.png?v=1668536057');
};

/* Product Description/Nutrition Facts Tabs */
function openTab(tabName) {
  var i;
  var x = document.getElementsByClassName("tab-content");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  document.getElementById(tabName).style.display = "block";
}

/* Hides content until page is loaded */
window.addEventListener('load', function () {
  document.getElementsByTagName("html")[0].style.visibility = "visible";
});

/*----- Starts Loyalty Lion Scripts -----*/
function llHideYourTier(){
  $('th#bronzeTierNotif').css('visibility','hidden');
  $('th#silverTierNotif').css('visibility','hidden');
  $('th#goldTierNotif').css('visibility','hidden');
};


function llLoginCheck(){
  console.log('llLoginCheck function called.');
  var myOrdersDisplay = $('#customer_myorders_li').css('display');
  console.log('var myOrdersDisplay: '  + myOrdersDisplay);
  if (myOrdersDisplay == 'list-item') { 
      console.log('Logged in to Loyalty Lion');
      $('#llLoggedOut').hide();
      $('#llLoggedIn').show();
      $('.llNavIem').show();
  } else {
    console.log('Not Logged in to Loyalty Lion');      
      $('#llLoggedIn').hide();
      $('#llLoggedOut').show();
      $('.llNavIem').hide();
      llHideYourTier();
  };
};

$(document).ready(function() {
llLoginCheck();
});

function getPointsApproved() {
    /* Get Approved Points */
    console.log('getPointsApproved function started.');
    let llPointsApproved = window.loyaltylion.customer.pointsApproved; //Capture approved points
    sessionStorage.setItem('llPointsApproved',llPointsApproved); //Add approved points to browser storage
    var llPointsApprovedNum = parseInt(llPointsApproved, 10); //Convert approved points from string to number

    /* Get Tier */
    //8069 - Gold Tier
    //8068 - Silver Tier
    //8067 - Bronze Tier

    var llTierCode = window.loyaltylion.customer.loyaltyTierMembership.loyaltyTierId; //Capture tier ID
    console.log('llTierCode: ' + llTierCode);
    var llTierName = '';

    if (llTierCode == '8069'){
           llTierName = 'Gold';
           console.log('llTierName: ' + llTierName);
           $('.ll-points-wrapper').css('display','none');
           $('th#bronzeTierNotif').css('visibility','hidden');
           $('th#silverTierNotif').css('visibility','hidden');
           $('th#goldTierNotif').css('display','table-cell');
        } else if (llTierCode == '8068') {
            llTierName = 'Silver'; 
            console.log('llTierName: ' + llTierName);
            $('th#bronzeTierNotif').css('visibility','hidden');
            $('th#silverTierNotif').css('display','table-cell');
            $('th#goldTierNotif').css('visibility','hidden');
        } else if (llTierCode == '8067') {
            llTierName = 'Bronze';
            console.log('llTierName: ' + llTierName);
            $('th#bronzeTierNotif').css('display','table-cell');
            $('th#silverTierNotif').css('visibility','hidden');
            $('th#goldTierNotif').css('visibility','hidden');
        } else {
          $('th#bronzeTierNotif').css('visibility','hidden');
          $('th#silverTierNotif').css('visibility','hidden');
          $('th#goldTierNotif').css('visibility','hidden');
        }



  /* CSS Adjustments to Avoid Elements Colliding*/  
    function llPointsApprovedMarginTop(){
        $('.ll-points-ticker-approved').addClass('ll-points-ticker-approved-2000-2499');
          $('.ll-points-wrapper').addClass('ll-points-wrapper-2000-2499');
      };
      function llClearClasses(){
        $('.ll-points-ticker-approved').removeClass('ll-points-ticker-approved-2000-2499');
          $('.ll-points-wrapper').removeClass('ll-points-wrapper-2000-2499');
      };


    //Display Next Reward on Progress Bar and Summary
        function llNextRewardCalc(){
            var llPointsToNextReward = llnextReward  - llPointsApprovedNum;
            console.log('llPointsToNextReward: ' + llPointsToNextReward);
            $('.points-to-next-reward').text(llPointsToNextReward);//Displays points to next reward on Summary Box
            $('.ll-points-to-next-reward').text(llPointsToNextReward);//Displays points to next reward on progress bar
            var llPointsPercentRewardNumber = llnextReward / llnextTier * 100;
            console.log('llPointsPercentRewardNumber: ' + llPointsPercentRewardNumber);
            var llPointsPercentRewardNumberString = llPointsPercentRewardNumber.toString();
            var llPointsPercentReward = llPointsPercentRewardNumberString + '%';
            console.log('llPointsPercentReward: ' + llPointsPercentReward);
            $('.ll-points-ticker-next-reward').css('margin-left', llPointsPercentReward);//Positions next reward ticker on progress bar
        }
        function llNextRewardCalcSilver(){
            var llPointsToNextReward = llnextReward  - llPointsApprovedNum;
            console.log('llPointsToNextReward: ' + llPointsToNextReward);
            $('.points-to-next-reward').text(llPointsToNextReward);//Displays points to next reward on Summary Box
            $('.ll-points-to-next-reward').text(llPointsToNextReward);//Displays points to next reward on progress bar
            var llPointsPercentRewardNumber = (llnextReward - tierSubtractor) / (llnextTier - tierSubtractor) * 100;
            console.log('llPointsPercentRewardNumber: ' + llPointsPercentRewardNumber);
            var llPointsPercentRewardNumberString = llPointsPercentRewardNumber.toString();
            var llPointsPercentReward = llPointsPercentRewardNumberString + '%';
            console.log('llPointsPercentReward: ' + llPointsPercentReward);
            $('.ll-points-ticker-next-reward').css('margin-left', llPointsPercentReward);//Positions next reward ticker on progress bar
        }


    if (llPointsApprovedNum < 2500) {
        console.log('Bronze Tier: Under 2500 points.');
        var llnextTier = 2500;
      
        //Display Approved Points on Progress Bar
        var llPointsPercentTierNumber = llPointsApprovedNum / llnextTier * 100;
        var llPointsPercentTierNumberString = llPointsPercentTierNumber.toString();
        var llPointsPercentTier = llPointsPercentTierNumberString + '%';
        //console.log('llPointsPercentTier: ' + llPointsPercentTier);
        $('.ll-points-progress-bar').css('width', llPointsPercentTier);
      
              
        //Display Next Tier on Progress Bar and Summary
        $('.ll-points-ticker-next-tier-number').html(llnextTier);         
        //console.log('llPointsPercentTier: ' + llPointsPercentTier);
        $('.ll-points-ticker-approved').css('margin-left',llPointsPercentTier);
        let llPointsToNextTier = llnextTier - llPointsApprovedNum;
        $('.points-to-next-tier').text(llPointsToNextTier);
      
      
      switch (true) {
          case (llPointsApprovedNum < 500):
            var llnextReward = 500; 
              llNextRewardCalc();
            llClearClasses();
              break;
          case (llPointsApprovedNum < 1000):
              var llnextReward = 1000; 
              llNextRewardCalc();
            llClearClasses();
              break;
          case (llPointsApprovedNum < 1500):
              var llnextReward = 1500; 
              llNextRewardCalc();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 2000):
              var llnextReward = 2000; 
              llNextRewardCalc();
            llClearClasses();
            break;
          default:
            var llnextReward = 2500; 
              llNextRewardCalc();
            llPointsApprovedMarginTop();
          break;
      }
      
    } else if (llPointsApprovedNum < 10000) {
        console.log('Silver Tier: Between 2500 and 9,999 points.');
        var llnextTier = 10000;
        var tierSize = 7500;
        var tierSubtractor = 2500;
      
        //Display Approved Points on Progress Bar
        var llPointsPercentTierNumber = (llPointsApprovedNum - tierSubtractor) / tierSize * 100;
        var llPointsPercentTierNumberString = llPointsPercentTierNumber.toString();
        var llPointsPercentTier = llPointsPercentTierNumberString + '%';
        console.log('llPointsPercentTier: ' + llPointsPercentTier);
        $('.ll-points-progress-bar').css('width', llPointsPercentTier);
      
              
        //Display Next Tier on Progress Bar and Summary
        $('.ll-points-ticker-next-tier-number').html(llnextTier);         
        console.log('llPointsPercentTier: ' + llPointsPercentTier);
        $('.ll-points-ticker-approved').css('margin-left',llPointsPercentTier);
        var llPointsToNextTier = llnextTier - llPointsApprovedNum;
        $('.points-to-next-tier').text(llPointsToNextTier);
      
      
      
      switch (true) {
          case (llPointsApprovedNum < 3000):
            var llnextReward = 3000; 
              llNextRewardCalcSilver();
            llClearClasses();
              break;
          case (llPointsApprovedNum < 3500):
              var llnextReward = 3500; 
              llNextRewardCalcSilver();
            llClearClasses();
              break;
          case (llPointsApprovedNum < 4000):
              var llnextReward = 4000; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 4500):
              var llnextReward = 4500; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 5000):
              var llnextReward = 5000; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 5500):
              var llnextReward = 5500; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 6000):
              var llnextReward = 6000; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 6500):
              var llnextReward = 6500; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 7000):
              var llnextReward = 7000; 
              llNextRewardCalc();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 7500):
              var llnextReward = 7500; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 8000):
              var llnextReward = 8000; 
              llNextRewardCalcSilver();
            llClearClasses();
            break;
          case (llPointsApprovedNum < 8500):
              var llnextReward = 8500; 
              llNextRewardCalcSilver();
            llPointsApprovedMarginTop();
            break;
          case (llPointsApprovedNum < 9000):
              var llnextReward = 9000; 
              llNextRewardCalcSilver();
            llPointsApprovedMarginTop();
            break;
          case (llPointsApprovedNum < 9500):
              var llnextReward = 9500; 
              llNextRewardCalcSilver();
            llPointsApprovedMarginTop();
            break;
          default:
            var llnextReward = 10000; 
              llNextRewardCalcSilver();
            llPointsApprovedMarginTop();
          break;
      }
    } 
    
};

function llPointsInit(){
    //console.log('llPointsInit function called.');
    //alert(JSON.stringify(window.loyaltylion.customer));
      getPointsApproved();
    //console.log('llPointsApproved: ' + llPointsApproved);
};

/* Polling - https://davidwalsh.name/javascript-polling */
function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
      // If the condition is met, we're done!
      var result = fn();
      if(result) {
          resolve(result);
      }
      // If the condition isn't met but the timeout hasn't elapsed, go again
      else if (Number(new Date()) < endTime) {
          setTimeout(checkCondition, interval, resolve, reject);
      }
      // Didn't match and too much time, reject!
      else {
          reject(new Error('timed out for ' + fn + ': ' + arguments));
      }
  };

  return new Promise(checkCondition);
}

// Usage:  ensure element is visible
poll(function() {
return window.loyaltylion.customer;
}, 8000, 150).then(function() {
  // Polling done, now do something else!
  //console.log('Condition has been met.');
  //console.log('Window.loyaltylion: ' + window.loyaltylion);
  llPointsInit();
}).catch(function() {
  // Polling timed out, handle the error!
  console.log('Polling timed out.');
});


/* Accordion */
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
/*----- Ends Loyalty Lion Scripts -----*/

/* PDP Toggles mutiple flavor nutrition facts images */
function nut_facts_01_active(){
  console.log('nut_facts_01_active function started.');
  let nutriImgWrapper = document.getElementsByClassName('sfl-prod-nutri-img');
  for (var i=0;i<nutriImgWrapper.length;i+=1){
    nutriImgWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-prod-nutri-img-01').style.display = 'block';
  let nutCat = document.getElementsByClassName('sfl-nut-facts-cat');
  for (var i=0;i<nutCat.length;i+=1){
    nutCat[i].classList.remove('sfl-nut-facts-cat-active');
  }
  document.getElementById('sfl-nut-facts-cat-01').classList.add('sfl-nut-facts-cat-active');
};

function nut_facts_02_active(){
  console.log('nut_facts_02_active function started.');
  let nutriImgWrapper = document.getElementsByClassName('sfl-prod-nutri-img');
  for (var i=0;i<nutriImgWrapper.length;i+=1){
    nutriImgWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-prod-nutri-img-02').style.display = 'block';
  let nutCat = document.getElementsByClassName('sfl-nut-facts-cat');
  for (var i=0;i<nutCat.length;i+=1){
    nutCat[i].classList.remove('sfl-nut-facts-cat-active');
  }
  document.getElementById('sfl-nut-facts-cat-02').classList.add('sfl-nut-facts-cat-active');
};

function nut_facts_03_active(){
  console.log('nut_facts_03_active function started.');
  let nutriImgWrapper = document.getElementsByClassName('sfl-prod-nutri-img');
  for (var i=0;i<nutriImgWrapper.length;i+=1){
    nutriImgWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-prod-nutri-img-03').style.display = 'block';
  let nutCat = document.getElementsByClassName('sfl-nut-facts-cat');
  for (var i=0;i<nutICat.length;i+=1){
    nutCat[i].classList.remove('sfl-nut-facts-cat-active');
  }
  document.getElementById('sfl-nut-facts-cat-03').classList.add('sfl-nut-facts-cat-active');
};

function nut_facts_04_active(){
  console.log('nut_facts_04_active function started.');
  let nutriImgWrapper = document.getElementsByClassName('sfl-prod-nutri-img');
  for (var i=0;i<nutriImgWrapper.length;i+=1){
    nutriImgWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-prod-nutri-img-04').style.display = 'block';
  let nutCat = document.getElementsByClassName('sfl-nut-facts-cat');
  for (var i=0;i<nutICat.length;i+=1){
    nutCat[i].classList.remove('sfl-nut-facts-cat-active');
  }
  document.getElementById('sfl-nut-facts-cat-04').classList.add('sfl-nut-facts-cat-active');
};

/* PDP Toggles mutiple flavor ingredient lists */
function ing_01_active(){
  console.log('ing_01_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-01-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-01').classList.add('sfl-ing-flavor-active');
};

function ing_02_active(){
  console.log('ing_02_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-02-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-02').classList.add('sfl-ing-flavor-active');
};

function ing_03_active(){
  console.log('ing_03_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-03-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-03').classList.add('sfl-ing-flavor-active');
};

function ing_04_active(){
  console.log('ing_04_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-04-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-04').classList.add('sfl-ing-flavor-active');
};

function ing_05_active(){
  console.log('ing_05_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-05-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-05').classList.add('sfl-ing-flavor-active');
};

function ing_06_active(){
  console.log('ing_06_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-06-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-06').classList.add('sfl-ing-flavor-active');
};

function ing_07_active(){
  console.log('ing_07_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-07-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-07').classList.add('sfl-ing-flavor-active');
};

function ing_08_active(){
  console.log('ing_08_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-08-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-08').classList.add('sfl-ing-flavor-active');
};

function ing_09_active(){
  console.log('ing_09_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-09-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-09').classList.add('sfl-ing-flavor-active');
};

function ing_10_active(){
  console.log('ing_10_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-10-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-10').classList.add('sfl-ing-flavor-active');
};

function ing_11_active(){
  console.log('ing_11_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-11-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-11').classList.add('sfl-ing-flavor-active');
};

function ing_12_active(){
  console.log('ing_12_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-12-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-12').classList.add('sfl-ing-flavor-active');
};

function ing_13_active(){
  console.log('ing_13_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-13-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-13').classList.add('sfl-ing-flavor-active');
};

function ing_14_active(){
  console.log('ing_14_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-14-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-14').classList.add('sfl-ing-flavor-active');
};

function ing_15_active(){
  console.log('ing_15_active function started.');
  let ingWrapper = document.getElementsByClassName('sfl-flavor-ing-wrapper');
  for (var i=0;i<ingWrapper.length;i+=1){
    ingWrapper[i].style.display = 'none';
  }
  document.getElementById('sfl-flavor-15-ing-wrapper').style.display = 'block';
  let flavor = document.getElementsByClassName('sfl-ing-flavor');
  for (var i=0;i<flavor.length;i+=1){
    flavor[i].classList.remove('sfl-ing-flavor-active');
  }
  document.getElementById('sfl-ing-flavor-15').classList.add('sfl-ing-flavor-active');
};